/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of space on the Fuel-Up Adventure board
 * @export
 */
export const FuelUpSpaceType = {
    start: 'start',
    fuel_stop: 'fuel_stop',
    vault_zone: 'vault_zone',
    action_space: 'action_space',
    bonus_zone: 'bonus_zone',
    prestige_gate: 'prestige_gate',
    chest: 'chest',
    shop: 'shop',
    challenge: 'challenge',
    mini_game: 'mini_game',
    reward_space: 'reward_space',
    spin_wheel: 'spin_wheel'
} as const;
export type FuelUpSpaceType = typeof FuelUpSpaceType[keyof typeof FuelUpSpaceType];


export function instanceOfFuelUpSpaceType(value: any): boolean {
    for (const key in FuelUpSpaceType) {
        if (Object.prototype.hasOwnProperty.call(FuelUpSpaceType, key)) {
            if (FuelUpSpaceType[key as keyof typeof FuelUpSpaceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FuelUpSpaceTypeFromJSON(json: any): FuelUpSpaceType {
    return FuelUpSpaceTypeFromJSONTyped(json, false);
}

export function FuelUpSpaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpSpaceType {
    return json as FuelUpSpaceType;
}

export function FuelUpSpaceTypeToJSON(value?: FuelUpSpaceType | null): any {
    return value as any;
}

export function FuelUpSpaceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FuelUpSpaceType {
    return value as FuelUpSpaceType;
}

